/// <amd-module name="Build/Admin/Common/Stores/SignalRStore" />
import { Store } from "VSS/Reflux/Store";

export const enum SignalRState {
    Connecting = 1,
    Connected = 2,
    Disconnected = 3
}

export class SignalRStore extends Store {
    public state: SignalRState = SignalRState.Disconnected;

    constructor() {
        super("SignalRStoreChanged");
    }

    public updateSignalRState = (state: SignalRState): void => {
        this.state = state;
        this.emitChanged();
    }
}
